<script setup>
    import {  onMounted,ref} from 'vue'
    import { configure, defineRule, } from 'vee-validate';
    import { localize } from '@vee-validate/i18n';
    import ButtonBasic from '../../common/components/form/ButtonBasic.vue'
    import ButtonSubmit from '../../common/components/form/ButtonSubmit.vue'
    import InputRadios from '../../common/components/form/InputRadios.vue'
    import InputSelect from '../../common/components/form/InputSelect.vue'
    import InputText from '../../common/components/form/InputText.vue'
    import InputTextarea from '../../common/components/form/InputTextarea.vue'
    import InputUpload from '../../common/components/form/InputUpload.vue'
    import IllustrationPlane from '../../common/components/illustrations/IllustrationPlane.vue'

          const props = defineProps({
            isCandidatureSpontane: {
              type: Boolean,
            },
            title: {
              type: String,
              default: '',
            },
            posteTitle: {
              type: String,
              default: '',
            },
          });
          const origin = ref(null)
          const success= ref(false)
          const $inputs= ref(null)
          const $form= ref(null)
          const $submit= ref(null)
          const formData= ref({
            captcha: '',
            title: this.title,
            civility: '',
            lastname: '',
            firstname: '',
            address: '',
            zipcode: '',
            town: '',
            country: '',
            phone: '',
            email: '',
            training: '',
            school: '',
            project: '',
            availability: '',
            wage: '',
            resume: '',
            cover: '',
          });
          const files =  ref({});
          function checkSubmitServerErrors(inputs) {
              const erroredInputs = [...this.$inputs].filter((input) =>
                input.classList.contains('error')
              )

              erroredInputs.forEach((input) => {
                const name = this.getInputName(input.name)

                this.errors.add({
                  scope: 'form-rh',
                  field: name[0] && !name[1] ? name[0] : name[1],
                  msg: 'Ce champ est obligatoire',
                })
            })
          }
          function fetchFilesInputs() {
            const $inputs = this.$form.querySelectorAll("input[type='file']")
            return [...$inputs].reduce((inputs, input) => {
              const wrapper = input.closest('.js-form-type-webform-document-file')
              const inputName = this.getInputName(input.name)[1]
              inputs[inputName] = {
                $el: input,
                $wrapper: wrapper,
              }
              return inputs
            }, {})
          }
          function submitForm(token) {
            this.formData.captcha = token
            this.validate('form-rh')
          }
          function validate(scope) {
            this.$validator
              .validateAll(scope)
              .then(this.populateAndSendForm.bind(this))
          }
          function populateAndSendForm(result) {
            if (result) {
              this.fillForm()
              this.updateDatalayer()
              const mouseEvent = new MouseEvent('click')
              this.$submit.dispatchEvent(mouseEvent)
            }
          }
          function fillData() {
            ;[...this.$inputs].forEach((input) => {
              const name = this.getInputName(input.name)[0]
              const value = input.value
              if (name && value && this.formData.hasOwnProperty(name)) {
                this.formData = {
                  ...this.formData,
                  [name]: input.value,
                }
              }
            })
          }
          function fillForm() {
            this.$inputs.forEach(this.fillInput.bind(this))
          }
          function fillInput(input) {
            if (input.type === 'radio') {
              const name = input.name
              input.checked = input.value === this.formData[name]
            } else {
              const name = this.getInputName(input.name)[0]
              if (name && this.formData.hasOwnProperty(name)) {
                input.value = this.formData[name]
              }
            }
          }
          function getInputName(realName) {
            return realName.split(/\[(.*)\]/)
          }
          function updateDatalayer() {
            // Retrieve page title
            let title = this.$el.querySelector('h1')
            const candidature_title = 'Vous_envoyez_une_candidature_spontanee'

            if (title) {
              const formData = {
                event: 'form_confirmation',
                form_type: 'Formulaire_RH',
                form_name: this.isCandidatureSpontane === true ? this.title : candidature_title
                  .trim()
                  .replace(/\s\s+/g, ' ')
                  .replace(/["+?!]/g, '')
                  .replace(/[#_', ]/g, '_')
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, ''),

                form_category: this.formData.training
                  .trim()
                  .replace(/[#_',\/]/g, '_')
                  .replace(/["+?! ]/g, '')
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, ''),
              }
              window.dataLayer.push(formData)
            }
          }

            // Configure localization
            configure({
              generateMessage: localize('fr', {
                attributes: {
                  civility: 'civilité',
                  lastname: 'nom',
                  firstname: 'prénom',
                  address: 'adresse',
                  zipcode: 'code postal',
                  town: 'ville',
                  country: 'pays',
                  phone: 'téléphone',
                  email: 'email',
                  training: 'formation',
                  school: 'école',
                  project: 'projet professionnel',
                  availability: 'disponibilités',
                  wage: 'prétentions salariales',
                  resume: 'cv',
                  cover: 'lettre de motivation',
                }
              })
            });

            // Define custom rule
            defineRule('file_ext', (value, extensions) => {
              const ext = value.split('.').pop(); // Get the file extension
              return extensions.includes(ext) ? true : `Le champ doit être de type ${extensions.join(', ')}.`;
            });
            onMounted(() => {
              const confirmation = origin.value.querySelector(
                '.webform-confirmation'
              )
              const success_att = confirmation !== null

              $form = origin.value.querySelector('form')
              $inputs = this.$form.querySelectorAll('input,textarea,select')
              $submit = [...this.$inputs].find((input) => input.name === 'op')

              if (!success_att) {
                files = fetchFilesInputs()
                checkSubmitServerErrors()
                fillData()
              }

              success = success_att

              if (isCandidatureSpontane) {
                formData.project = posteTitle
              }

              // Disable textarea for "candidature spontannée" (attribute is added only on container)
              const textarea = this.$el.querySelector('textarea.input')

              if (textarea && textarea.closest('div.control[disabled="disabled"]')) {
                textarea.disabled = 'disabled'
              }
            })

</script>
<style scoped lang="sass">
@import ../../common/styles/mixins
@import ../../common/styles/settings
@import form-rh
</style>
